module.exports = __webpack_public_path__ + "img/47_3.c89a8f11.png";